import axios from 'axios';
import { API_URL } from './api';

export const stylesService = {
    getAll () {
        console.log('stylesService: getAll');

        return axios
            .get(`${API_URL}/styles`)
            .then((response) => {
                if (response.data.list)
                {
                    return response.data.list;
                }

                return response;
            });
    },
};

export default stylesService;
